import { Box } from '@mui/material';
import type { PointerEvent as ReactPointerEvent } from 'react';

interface ColumnResizeHandleProps {
  columnKey: string;
  onResizeStart: (columnKey: string, startX: number, startWidth: number) => void;
}

/**
 * Drag handle for a resizable table column header (flank#4819). The parent
 * `TableCell` must be `position: relative` for this to anchor to its edge.
 * Reads the cell's own rendered width at drag start rather than a
 * precomputed default, so it works whether the column is currently sized by
 * `%`, a fixed value, or its content.
 */
const ColumnResizeHandle = ({ columnKey, onResizeStart }: ColumnResizeHandleProps) => (
  <Box
    onPointerDown={(event: ReactPointerEvent<HTMLDivElement>) => {
      event.preventDefault();
      const cell = event.currentTarget.closest('th,td');
      onResizeStart(columnKey, event.clientX, cell?.getBoundingClientRect().width ?? 0);
    }}
    sx={{
      position: 'absolute',
      top: 0,
      right: -4,
      height: '100%',
      width: 8,
      cursor: 'col-resize',
      zIndex: 1,
      '&:hover': { backgroundColor: 'divider' },
    }}
  />
);

export default ColumnResizeHandle;
